import React from 'react'
import styled from 'styled-components'
import GlobalCell from './GlobalCell'
import fillNullCashflowData from '../../../helpers/fillNullCashflowData'

const Container = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(5, 1fr);
  flex-direction: row;
  align-items: center;
  padding: 10px 10px 10px 0px;
  font-weight: ${props => props.bold ? 'bold' : 'normal'};
`
const Title = styled.div`
  text-align: right;
`
export default class GlobalRow extends React.Component {
  renderCells = () => {
    const { data, years } = this.props
    return fillNullCashflowData(data, years).map(datum => {
      return <GlobalCell data={datum.data} key={`${datum.year}-${datum.category}`} />
    })
  }
  render() {
    const { title, bold } = this.props
    return (
      <Container bold={bold}>
        <Title>{title}</Title>
        {this.renderCells()}
      </Container>
    )
  }
}